import BasicContentMediaGrid from './BasicContentMediaGrid';

export { type BasicContentMediaGridProps } from './BasicContentMediaGrid';
export default BasicContentMediaGrid;
